import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { TipoAltroSoggetto } from 'src/app/models/tipo-altro-soggetto';
import { TipoAltroSoggettoService } from 'src/app/services/tipo-altro-soggetto.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { TipiAltroSoggettoFormComponent } from './dialogs/form/form.component';

@Component({
  selector: 'tipi-altro-soggetto',
  templateUrl: './tipi-altro-soggetto.component.html',
  styleUrls: ['./tipi-altro-soggetto.component.scss']
})
export class TipiAltroSoggettoComponent implements OnInit {

  headingText: string = 'Tipi di altro soggetto';


  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),

  ];
  constructor(public tipoAltroSoggettoService: TipoAltroSoggettoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<TipiAltroSoggettoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un tipo di altro soggetto';
    }
  }

  async ngOnInit() {

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (tipoAltroSoggetto: TipoAltroSoggetto) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il tipo di altro soggetto ${tipoAltroSoggetto.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.tipoAltroSoggettoService.delete(tipoAltroSoggetto);
          this.toast.success('Tipo di altro soggetto eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione tipo di altro soggetto fallita.", "Errore!");
    }
  }



  editFunction = async (tipoAltroSoggetto: TipoAltroSoggetto) => {
    try {
      let dialogRef = this.dialog.open(TipiAltroSoggettoFormComponent, { data: tipoAltroSoggetto });
      dialogRef.afterClosed().subscribe(async (data: TipoAltroSoggetto) => {
        if (data) {

          Object.assign(tipoAltroSoggetto, data);

          await this.tipoAltroSoggettoService.edit(tipoAltroSoggetto);

          this.toast.success('Tipo di altro soggetto modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica tipo di altro soggetto fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(TipiAltroSoggettoFormComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(tipoAltroSoggetto?: TipoAltroSoggetto) {
    if (tipoAltroSoggetto) {
      try {
        await this.tipoAltroSoggettoService.create(tipoAltroSoggetto)
        this.toast.success('Tipo di altro soggetto creato!')
      }
      catch (e) {
        this.toast.error('Creazione tipo di altro soggetto fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }


  applyFilter(searchedName: string) {
    this.search = {
      nome: searchedName,
    }
  }
}
